mutation PurchaseOrderDelete($input: PurchaseOrderDeleteInput!) {
  purchaseOrderDelete(input: $input) {
    clientMutationId
    deletedEntities {
      rowTimestamp
      id
    }
  }
}
